<template>
  <page-outline :title="$t('bank_accounts.add_bank_account')"
    icon="icon-credit_cards">
    <template slot="pageContent">
      <b-row class="form-group">
        <b-col sm="6">
          <form-write-group-label-input v-model="name" isMandatory
            inputType="text"
            :inputLabel="$t('common.nme')"
            :placeholderValue="$t('bank_accounts.bank_account_name')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input isMandatory
            inputType="listeSelect"
            :inputLabel="$t('common.account_zone')">
            <select class="form-control" id="sel4" readonly v-model="zone">
              <option v-for="country in countries" :key="country.id"
                :value="country"
                :disabled="country.disabled"
                :selected="country.selected">
                {{ $t('zoneCodes.' + country.label) }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <b-row v-for="accountLabel in zone.accountLabel" :key="accountLabel">
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="zone.values[accountLabel]" isMandatory
            inputType="text"
            :inputLabel="$t(accountLabel)"
            :placeholderValue="$i18n.t(accountLabel)">
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </template>
    <template slot="footerButtons">
      <b-row>
        <b-col md="2" offset-md="9" cols="6" offset="6">
          <f7-button class="milkyBlockBlack button-action"
            title="Register"
            @click="addAccount()">
            <f7-icon fa="save"></f7-icon>
            <span>{{ $t('common.sve') }}</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>


<script>
import _ from 'lodash'

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {createForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'
import {validateAccountFormat} from '@/helpers/validator'

export default {
  name: 'AddBankAccount',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      name: '',
      zone: {
        id: 0,
        label: this.$t('zoneCodes.slct_zone'),
        disabled: true,
        selected: true
      },
      zoneCode: '',
      countries: '',
      countryPicker: ''
    }
  },
  created () {
    // DEFAULT
    // this.zone = 'EU'
    let that = this
    let label = []

    that.countries = _.cloneDeep(this.$engine.bankAccounts.getZoneCode())
    that.countries.forEach((x, y) => {
      label.push(this.$t('zoneCodes.' + x.label))
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = p.value[0]
        that.zone = _.cloneDeep(that.$engine.bankAccounts.getZoneData(p.value[0]))
      }
    })
  },
  methods: {
    addAccount () {
      let that = this

      // Check input formats
      if (this.name === '') {
        this.$f7.alert(
            this.$i18n.t('errors.please_enter_mandatory',
              {invaliddata: this.$i18n.t('common.nme')}),
            this.$i18n.t('errors.missing_label',
              {invaliddata: this.$i18n.t('common.nme')}))
        return
      }
      if (this.zone.accountNumberField == null) {
        this.$f7.alert(
            this.$i18n.t('errors.please_enter_mandatory',
              {invaliddata: this.$i18n.t('common.account_zone')}),
            this.$i18n.t('errors.missing_label',
              {invaliddata: this.$i18n.t('common.account_zone')})
        )
      }
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.accountLabel && this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t('errors.change_to_valid',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        } else {
          // Account zone is mandatory
          this.$f7.alert(
              this.$i18n.t('errors.please_enter_mandatory',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
              this.$i18n.t('errors.missing_label',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
          )
          return
        }
      }

      // Format IBAN
      let localIban = createForeignIban(this.zone)

      // Create account
      this.$engine.bankAccounts
        .create({
          name: this.name,
          iban: localIban,
          zoneCode: this.zone.label
        })
        .then(resp => {
          this.$f7.modal({
            title: this.$i18n.t('success.added_success', {data: this.$i18n.t('common.act')}),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.iban = ''
            that.name = ''
            that.zone = 'EU'
            that.sortCode = ''
            that.accountNumber = ''
            loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          this.handleError(err) // mixins errorHandlerMixins
        })
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// CMAddBankAccount.vue?c13b519c